// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { OperationsPost } from '../../../../types/server/modules/operations/post';

export type * from '../../../../types/server/modules/operations/post';

export const createPost = ( requests: Requests ): OperationsPost => ({
  propose_operation: Object.assign(( params, body,headers ) => {
      return requests.post( `/operations/:type/propose`, { ...params, body }, headers );
    }, { operation: 'operations:propose-operation', route: 'POST /operations/:type/propose', subdomain: 'operations', visibility: 'private' } as const ),
  approve_operation: Object.assign(( params, body,headers ) => {
      return requests.post( `/operations/:runId/approve`, { ...params, body }, headers );
    }, { operation: 'operations:approve-operation', route: 'POST /operations/:runId/approve', subdomain: 'operations', visibility: 'private' } as const ),
  reject_operation: Object.assign(( params, body,headers ) => {
      return requests.post( `/operations/:runId/reject`, { ...params, body }, headers );
    }, { operation: 'operations:reject-operation', route: 'POST /operations/:runId/reject', subdomain: 'operations', visibility: 'private' } as const )
});
